var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("AttachmentsDialog.title"),
        visible: _vm.visible,
        "before-close": _vm.handleClose,
        width: "500px"
      }
    },
    [
      _c("attachment-uploader", {
        attrs: {
          attachments: _vm.fileList,
          participant: _vm.participant,
          "legal-entity": _vm.legalEntity,
          loading: _vm.loading
        },
        on: {
          "attachment-added": _vm.handleAttachmentAdded,
          "attachment-removed": _vm.handleRemove,
          loading: _vm.setLoading
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }